class ContactsDiscovery {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/contacts-discovery`;
    this.apiClient = apiClient;

  }

  async createDiscoveryRequest(data) {

    const path = `${this.basePath}/requests`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getDiscoveryRequests() {

    const path = `${this.basePath}/requests`;

    return this.apiClient.get(path, {}, {});

  }

  async getDiscoveryRequestStatus(discoveryRequestId) {

    const path = `${this.basePath}/requests/:discoveryRequestId`;

    return this.apiClient.get(path, { discoveryRequestId }, {});

  }

  async deleteDiscoveryRequest(discoveryRequestId) {

    const path = `${this.basePath}/requests/:discoveryRequestId`;

    return this.apiClient.delete(path, { discoveryRequestId }, {});

  }

  async startExternalDiscovery(discoveryRequestId, data) {

    const path = `${this.basePath}/requests/:discoveryRequestId/external-sources`;

    return this.apiClient.post(path, { discoveryRequestId }, {}, data);

  }

  async getDiscoveredContacts(submissionId) {

    const path = `${this.basePath}/submissions/:submissionId/discovered-contacts`;

    return this.apiClient.get(path, { submissionId }, {});

  }

  async deleteDiscoveredContacts(discoveryIds) {

    const path = `${this.basePath}/discovered-contacts/delete`;

    return this.apiClient.post(path, {}, {}, { discoveryIds });

  }

}

export default ContactsDiscovery;
